import { Text } from "@mantine/core";
import adminClasses from "../AdminDashboardView/AdminDashboardView.module.css";
// import { ActionIcon, Group, Image, SegmentedControl, Select, Tooltip } from "@mantine/core";
// import { DateInput } from "@mantine/dates";
// import dayjs from "dayjs";
// import { applyDashboardRangeField } from "../../utils/dashboardDateRange";

const SalesDashboardHeader = () => (
  <div className={adminClasses.toolbar}>
    <div className={adminClasses.pageHeader} style={{ padding: 0 }}>
      <Text className={adminClasses.pageTitle}>Sales Overview</Text>
      <Text className={adminClasses.pageSubtitle}>Dashboard</Text>
    </div>

    {/* Filters disabled — crm/stats API does not use dashboard date/scope params yet
    <div className={adminClasses.toolbarGrow} />
    <Group gap={6} wrap="wrap" className={adminClasses.filterPill}>
      <SegmentedControl
        size="xs"
        className={adminClasses.segment}
        value={timeFrame}
        onChange={setTimeFrame}
        data={[
          { label: "Daily", value: "D" },
          { label: "Weekly", value: "W" },
          { label: "Monthly", value: "M" },
        ]}
      />
      <Group gap={6} wrap="nowrap" className={adminClasses.dateRange}>
        <DateInput
          value={filters.startDate}
          onChange={(value) => setFilters((prev) => applyDashboardRangeField(prev, "startDate", value))}
          placeholder="From"
          size="xs"
          className={adminClasses.compactDate}
          maxDate={new Date()}
        />
        <Text className={adminClasses.arrow}>–</Text>
        <DateInput
          value={filters.endDate}
          onChange={(value) => setFilters((prev) => applyDashboardRangeField(prev, "endDate", value))}
          placeholder="To"
          size="xs"
          className={adminClasses.compactDate}
          maxDate={new Date()}
          minDate={filters.startDate ? dayjs(filters.startDate).startOf("day").toDate() : undefined}
        />
      </Group>
      <div className={adminClasses.divider} />
      <Select
        size="xs"
        className={adminClasses.compactSelect}
        placeholder="Scope"
        data={[
          { label: "Both", value: "both" },
          { label: "Domestic", value: "domestic" },
          { label: "International", value: "international" },
        ]}
        value={scope || "both"}
        onChange={(value) => setScope(value || "both")}
        allowDeselect={false}
      />
      {(filters.startDate || filters.endDate) && (
        <Tooltip label="Reset dates" position="bottom" withArrow fz={11}>
          <ActionIcon
            variant="subtle"
            color="gray"
            size="xs"
            onClick={() => setFilters({ startDate: null, endDate: null })}
            aria-label="Reset date filter"
          >
            <Image src="/images/svg/cross.svg" w={10} h={10} alt="" />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
    */}
  </div>
);

export default SalesDashboardHeader;
